import { ChangeDetectionStrategy, Component, input, inject, signal, computed } from '@angular/core';
import { RunnableReportConfiguration } from '../../models/runnable_report';
import { asyncWrapper, AsyncWrapperComponent } from '@fry-it/risr-core';
import { ReportResult } from './report-result/report-result';
import { ReportForm } from './report-form/report-form';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { ReportRunState } from './report-run-state';

@Component({
  selector: 'risr-features-reports-report-run',
  imports: [
    MatButtonModule,
    AsyncWrapperComponent,
    ReactiveFormsModule,
    ReportResult,
    ReportForm,
  ],
  templateUrl: './report-run.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ReportRunState
  ]
})
export class ReportRun {
  report = input.required<RunnableReportConfiguration>();
  reportId = input.required<string>();
  runFor = input.required<string>();
  showType = input.required<'full' | 'embedded' | 'widget'>();

  reportReady = asyncWrapper(() => this.reportRunState.run(), { autoLoad: false});

  private readonly reportRunState = inject(ReportRunState);

  private readonly model = signal<any | undefined>(undefined);
  private readonly options = computed(() => {
    return {
      showType: this.showType(),
    }
  })

  ngOnInit() {
    this.reportRunState.initialize(this.reportId(), this.report().display, this.model(), this.options(), this.runFor());
  }

  run(model: any) {
    this.reportRunState.setModel(model);
    this.reportReady.load();
  }
}
